export function secondsToMinutes(seconds: number | null) {
	if (!seconds) return ''

	const mins = Math.floor(seconds / 60)
	const secs = seconds % 60
	return `${mins}:${secs.toString().padStart(2, '0')}`
}
